<template>
  <div class="">

    <!-- heroSection intro -->
    <section class="heroSection">
      <b-container fluid>
        <b-row class="intro-section justify-content-around">
          <b-col xl="6" lg="12" md="12" style="display: flex;align-items: center;margin-left: auto;">
            <div class="text-section">
              <div>
                <h1 class="mb-3"><b>ميديا تَخَطّي </b></h1>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>




    <!-- info greyBox -->
    <section class="greyBox">
      <div class="gridSection parentContainer">
        <b-container fluid>
          
          <div class="section-content">
            
            <div class="row">
              <div class="col-xl-3 col-md-4 col-sm-6 col-xs-6 mb-5">
                <div class="transBox mediaBox">
                  <div class="transBox-icon">
                    <img class="gridSection-img" src="../../src/assets/images/patients.png" alt="logo" />
                  </div>
                  <div style="display: flex;justify-content: start;align-items: center;padding: 0px 10px;">
                    <div class="ml-3">
                      <img width="50px" style="border-radius: 50%;" src="../assets/images/ceoPhoto.png">
                    </div>
                    <div style="text-align: right;">
                      <h5>
                        دورة التخلص من الإكتئاب
                      </h5>
                      <div>
                        <span class="text-muted">د.رنا مصطفى</span>
                        <br>
                        <span class="text-muted">منذ 3 سنوات </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-md-4 col-sm-6 col-xs-6 mb-5">
                <div class="transBox mediaBox">
                  <div class="transBox-icon">
                    <img class="gridSection-img" src="../../src/assets/images/patients.png" alt="logo" />
                  </div>
                  <div style="display: flex;justify-content: start;align-items: center;padding: 0px 10px;">
                    <div class="ml-3">
                      <img width="50px" style="border-radius: 50%;" src="../assets/images/ceoPhoto.png">
                    </div>
                    <div style="text-align: right;">
                      <h5>
                        دورة التخلص من الإكتئاب
                      </h5>
                      <div>
                        <span class="text-muted">د.رنا مصطفى</span>
                        <br>
                        <span class="text-muted">منذ 3 سنوات </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-md-4 col-sm-6 col-xs-6 mb-5">
                <div class="transBox mediaBox">
                  <div class="transBox-icon">
                    <img class="gridSection-img" src="../../src/assets/images/patients.png" alt="logo" />
                  </div>
                  <div style="display: flex;justify-content: start;align-items: center;padding: 0px 10px;">
                    <div class="ml-3">
                      <img width="50px" style="border-radius: 50%;" src="../assets/images/ceoPhoto.png">
                    </div>
                    <div style="text-align: right;">
                      <h5>
                        دورة التخلص من الإكتئاب
                      </h5>
                      <div>
                        <span class="text-muted">د.رنا مصطفى</span>
                        <br>
                        <span class="text-muted">منذ 3 سنوات </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-md-4 col-sm-6 col-xs-6 mb-5">
                <div class="transBox mediaBox">
                  <div class="transBox-icon">
                    <img class="gridSection-img" src="../../src/assets/images/patients.png" alt="logo" />
                  </div>
                  <div style="display: flex;justify-content: start;align-items: center;padding: 0px 10px;">
                    <div class="ml-3">
                      <img width="50px" style="border-radius: 50%;" src="../assets/images/ceoPhoto.png">
                    </div>
                    <div style="text-align: right;">
                      <h5>
                        دورة التخلص من الإكتئاب
                      </h5>
                      <div>
                        <span class="text-muted">د.رنا مصطفى</span>
                        <br>
                        <span class="text-muted">منذ 3 سنوات </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-md-4 col-sm-6 col-xs-6 mb-5">
                <div class="transBox mediaBox">
                  <div class="transBox-icon">
                    <img class="gridSection-img" src="../../src/assets/images/patients.png" alt="logo" />
                  </div>
                  <div style="display: flex;justify-content: start;align-items: center;padding: 0px 10px;">
                    <div class="ml-3">
                      <img width="50px" style="border-radius: 50%;" src="../assets/images/ceoPhoto.png">
                    </div>
                    <div style="text-align: right;">
                      <h5>
                        دورة التخلص من الإكتئاب
                      </h5>
                      <div>
                        <span class="text-muted">د.رنا مصطفى</span>
                        <br>
                        <span class="text-muted">منذ 3 سنوات </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br>
          </div>
        </b-container>
      </div>
    </section>


  </div>
</template>

<script>
  import store from "../store/index.js"
  import articles from "../components/ArticlesSection.vue"

  export default {
    name: 'Home',
    data() {
      return {
        langDec: {},
      }
    },
    
    components: {
      articles
    },
    methods: {
      goToRoute(name) {
        this.$router.push({
          name,
        }).catch(()=>{});
      },
    },
    created() {
      this.langDec = store.getters.getLangData
    }
  }
</script>

<style scoped>
  .heroSection .intro-section {
    background-image: url(../assets/images/mediaBG.png);
    background-size: cover;
    background-position: right center;
    width: auto;
    height: 450px !important;
    color: white;
  }
  .heroSection .text-section{
    display: flex;
    align-items: center;
    margin-right: 70px;
  }
  .heroSection .text-section h2 {
    
    font-size: 40px !important;
    font-weight: bolder !important;
    color: white;
  }

  .parentContainer {
    background-color: white !important;
    text-align: center;
    margin: 70px 40px ;
    
  }
  .mediaBox{
    box-shadow: 0px 0px 15px #c0c0c0;
    border-radius: 10px 10px 0px 0px;
    padding-bottom: 20px;
  }
  .transBox-icon img{
    width: 100%;
    height: 250px;
    object-fit: cover;
    margin: 0 auto;
    background-color: #ffffff;
    border-radius: 10px 10px 0px 0px;
    margin-bottom: 10px;
  }
  .transBox h5{
    font-size: 17px !important;
    font-weight: bold;
    text-align: right;
    margin-top: 15px;
  }
  .transBox .link{
    text-align: right !important; 
    font-size: 14px;
    margin-top: 15px;
    color: #006633;
  }
  .transBox .transBox-p{
    text-align: right;
    color: grey;
    margin-top: 15px;
    font-size: 13px;
  }

  .transBox-time{
    text-align: right;
    font-size: 12px;
    color: #6C757D;
    margin-bottom: -10px;
  }

  @media (max-width: 991.98px) {
    
    .intro-section {
      height: 550px !important;
    }
    .text-section h2 {
      font-size: 30px !important;
      font-weight: bolder !important;
    }
    
  }

  @media (max-width: 767.98px) {
    .intro-section {
      height: 350px !important;
    }
    
  }
</style>